import { UiMessageBubbleStoreContext } from "./_sotre/UiMessageBubbleStore";
import { useAtomValues } from "@deputy-ai/common/jotai";
import { DaAvatar } from "@deputy-ai/ui/avatar/DaAvatar";

export function UiMessageBubbleAvatar() {
  const {
    propsAtoms,
    use: { uiAvatarVisible },
  } = UiMessageBubbleStoreContext.useStore();

  const { avatar, participantName } = useAtomValues(propsAtoms);

  if (uiAvatarVisible === "placeholder") {
    return <span className="flex-[0_0_2.5rem]"></span>;
  }

  if (!uiAvatarVisible) {
    return null;
  }

  return (
    <DaAvatar
      src={avatar}
      size={40}
      fallback={participantName?.[0]?.toUpperCase()}
    />
  );
}
